import { Component, Inject, Input, EventEmitter, Output, ViewChild, OnChanges, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../../utils/utils";
import { DialogService } from "../../../services/dialog.service";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { SaveService } from "../../../services/save.service";
import { MatTable, MatTableDataSource } from "@angular/material/table";

@Component({
    selector: "harmonizedopmode-list",
    templateUrl: './harmonizedopmode-list.component.html',
    styleUrls: ['../../../style/list.component.less'],
    standalone: false
})

export class HarmonizedOperationModeListComponent implements OnInit, OnChanges {
    @Input('list') list: HarmonizedOperationMode[] = [];
    @Input('language') language: Language = <Language>{};
    @Output() onRefresh = new EventEmitter<{}>();

    @Input() isRowEditMode = false;

    selected: HarmonizedOperationMode = <HarmonizedOperationMode>{};

    clonedList: { [s: string]: HarmonizedOperationMode; } = {};

    columnsToDisplay = ['desc', 'customerDesc', 'actions'];

    public dataSource = new MatTableDataSource<HarmonizedOperationMode>();
    @ViewChild(MatTable, { static: true }) table!: MatTable<any>;


    subscriptionLanguage: any;
    subscriptionTenant: any;
    constructor(
        private defaults: DefaultValuesService
        , private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , private dialog: DialogService
        , private saveService: SaveService
    ) {
        this.dialog.tthis = this;
    }

    ngOnInit() {

        this.dialog.tthis = this;
        this.getHeader()
        this.subscriptionLanguage = this.defaults.languageMessageChanges$.subscribe(() => {
            this.getHeader()
        });
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getHeader()
        });
    }

    ngOnChanges() {
        this.dataSource.data = this.list;
    }

    getHeader() {
        if (this.defaults.isadminuser || !this.defaults.isReadonlyUser)
            this.columnsToDisplay = ['desc', 'customerDesc', 'actions'];
        else
            this.columnsToDisplay = ['desc', 'customerDesc'];
    }

    onRowEditInit(HarmonizedOperationMode: HarmonizedOperationMode) {
        this.saveService.addListener(this);
        this.clonedList[HarmonizedOperationMode.HarmonizedOperationModeID] = { ...HarmonizedOperationMode };
        if (Object.keys(this.clonedList).length !== 0) this.onShowSavebutton()
    }

    onShowSavebutton() {
        this.saveService.showSaveButton();
    }

    notTranslatedClass(text: string): string {
        return Utils.notTranslatedClass(text);
    }

    isToShowReference(): boolean {
        return this.defaults.language.LanguageId != Utils.getDefaultLaguangeID();
    }

    isEditingRow(element: HarmonizedOperationMode) {
        return this.clonedList[element.HarmonizedOperationModeID]
    }


    onRowEditCancel(HarmonizedOperationMode: HarmonizedOperationMode) {
        this.dataSource.data[this.dataSource.data.findIndex(x => x.HarmonizedOperationModeID === HarmonizedOperationMode.HarmonizedOperationModeID)] = this.clonedList[HarmonizedOperationMode.HarmonizedOperationModeID];
        delete this.clonedList[HarmonizedOperationMode.HarmonizedOperationModeID];

        if (Object.keys(this.clonedList).length === 0) this.saveService.showSaveButton(false)
        this.table.renderRows();
    }


    onSave() {
        for (let i in this.clonedList) {
            const index = this.dataSource.data.findIndex(x => x.HarmonizedOperationModeID === this.clonedList[i].HarmonizedOperationModeID)
            if (Object.entries(this.clonedList[i]).toString() !== Object.entries(this.dataSource.data[index]).toString()) {
                this.http
                    .post<HarmonizedOperationMode>(
                        this.baseUrl + Utils.getOperationModeAPI() + "mergeharmonizedopmode"
                        , this.dataSource.data[index]
                    )
                    .subscribe(
                        () => {
                            this.onRowEditCancel(this.clonedList[i])
                            this.onRefresh.emit({});
                        }
                        , error => {
                            this.dialog.showErrorDialog(error)
                            this.onRowEditCancel(this.clonedList[i])
                            delete this.clonedList[this.clonedList[i].HarmonizedOperationModeID];
                            this.table.renderRows();
                        }
                    );
            }
            else {
                delete this.clonedList[this.clonedList[i].HarmonizedOperationModeID];
            }
        }
    }

}